<template>
  <div class="ms-container">
      <div class="df no-pro" v-show="messageList.length==0">
        <img src="../../assets/img/home_default.png" alt="">
        <p>你还没有任何未读消息~</p>
      </div>
      <div class="ms-content" v-show="messageList.length>0" ref="list">
          <ul class="ms-list">
              <li class="df ms-item" v-for="(item,index) in messageList" :key="index" :class="{active: item.ReadStatus==0}">
                  <div class="ms-left">
                      <img :src="item.Avatar" alt="" >
                  </div>
                  <div class="ms-right">
                      <p class="font12">No.{{item.JobNo}} {{item.NickName}}　<span class="colorccc">{{item.CreationTime}}</span></p>
                      <p class="margin8">
                          <span class="color999" v-if="!item.AnswerUserID && item.Type==1">评论了你的图片</span>
                          <span class="color999" v-if="!item.AnswerUserID && item.Type==2">评论了你的文章</span>                          
                          <span class="color999" v-if="item.AnswerUserID">回复了你的评论</span>
                          <router-link tag="span" @click.native="setRead(item.Id,index,false)" :to="item.SourceType==2 ? ('/artDetail?id='+item.SourceID+'&sourceType='+item.Type) : ('/picDetail?id='+item.SourceID+'&sourceType='+item.Type+'&fId='+item.Id)" class="color69f" :id="item.SourceID">{{item.SourceTitle}}</router-link>
                          <span v-if="item.AnswerUserID && item.AnswerContent" v-html="item.AnswerContent"></span>
                      </p>
                      <p><span class="color999" v-if="item.AnswerUserID && item.AnswerContent">回复内容：</span>{{item.Content}}</p>
                  </div>
                  <div class="al-read" @click="setRead(item.Id,index,true)">删除</div>
              </li>
          </ul>
          <div class="paginate_container">
            <paginate
                v-show="pageCount>1"
                v-model="nowPage"
                :page-count="pageCount"
                :margin-pages="marginPages"
                :page-range="rangePage"
                :click-handler="pageEvent"
                prev-text
                next-text
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link-item'"
                :prev-class="'prev-item'"
                :prev-link-class="'prev-link-item'"
                :next-class="'next-item'"
                :next-link-class="'next-link-item'"
            ></paginate>
        </div>
      </div>
  </div>
</template>
<script>
import {getMessageList,setMessageRead} from "@/assets/js/modules/userApi"
import paginate from "vuejs-paginate";
export default {
    data(){
        return {
            userId: "",
            messageList: [],
            nowPage: 1,
            pageCount: 20,
            marginPages: 2,
            rangePage: 5,
            currentPage: 0,
            MaxCount: 10
        }
    },
    components: {
        paginate
    },
    created(){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.userId = userInfo.Id || 1;
        this.getMessageList();
    },
    methods: {
        pageEvent(e) {
            this.currentPage = e-1;
             this.getMessageList();
        },
        // 获取消息列表
        getMessageList(){
            let data = {
                UserID: this.userId,
                NewsCategory: 1,
                IsDesc: true,
                SkipCount:this.currentPage * this.MaxCount,
                MaxResultCount: this.MaxCount,
            };
            getMessageList(data).then(res=>{
                if(res.data.Success){
                    let result = res.data.Data;
                    if(result.length==0) return;
                    this.pageCount = Math.ceil(result.TotalCount / this.MaxCount);
                    this.$refs.list.scrollIntoView(true);
                    this.messageList = result.Items;
                }
                
            })
        },
        //设置已读
        setRead(id,index,isDelete){
            let Ids = [];
            Ids.push(id);
            let data = {
                Ids: Ids,
                UserID: this.userId,
                IsDelete: isDelete
            };
            setMessageRead(data).then(res=>{
                if(res.data.Success){
                    if(isDelete){
                        this.messageList.splice(index,1);
                    }else{
                        this.messageList[index].ReadStatus = 1;
                    }
                }
            })
        }
    }
}
</script>
<style scoped>
.ms-container{
    padding: 20px 0 60px;
    background-color: #fbfbfb;
}
.no-pro{
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #999;
  text-align: center;
  min-height: 600px;
}
.no-pro img{
  margin-top: 6%;
}
.no-pro p{
  font-size: 18px;
  line-height: 28px;
  margin-top: 2%;
}
.ms-content{
    max-width: 1280px;
    margin: 0 auto;
    padding: 30px;
    background-color: #fff;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    box-sizing: border-box;
    min-height: 600px;
}
.ms-item{
    position: relative;
    border: 1px solid #e7e7e7;
    background-color: #fbfbfb;
    border-radius: 5px; 
    margin-bottom: 20px;  
    padding: 20px 35px 20px 0;
    overflow: hidden;
}
.ms-item.active::before{
    position: absolute;
    content: "";
    top: 10px;
    left: 10px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #ff9933;
}
.ms-left{
    flex: 0 0 60px;
    width: 60px;
    padding: 0 3%;
}
.ms-left img{
    display: block;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #e7e7e7;
}
.ms-right{
    font-size: 14px;
    line-height: 1.5;
}
.ms-right span{
    margin-right: 0.5em;
}
.font12{
    font-size: 12px;
}
.colorccc{
    color: #ccc;
}
.color999{
    color: #999;
}
.color69f{
    color: #69f;
    cursor: pointer;
}
.color69f:hover{
    text-decoration: underline;
}
.al-read{
    position: absolute;
    right: 0;
    top: 0;
    line-height: 20px;
    height: 20px;
    font-size: 14px;
    padding: 0 10px;
    background-color: #eee;
    border-radius: 5px;
    cursor: pointer;
    display: none;
    color: #999;
    z-index: 100;
}
.al-read:hover{
    background-color: #ddd;
    color: #666;
}
.ms-item:hover .al-read{
    display: block;
}
.margin8{
    margin: 8px 0;
}
.paginate_container >>> .pagination {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.paginate_container >>> .page-item {
  margin: 0 6px;
}
.paginate_container >>> .page-item a {
  background: #f5f5f5;
  font-size: 14px;
  line-height: 2;
  border-radius: 14px;
  padding: 0 6px;
  outline: none;
}
.paginate_container >>> .page-item.active .page-link-item {
  background: #6aa9ff;
  color: #fff;
}

.paginate_container >>> .prev-link-item {
  display: block;
  width: 24px;
  height: 24px;
  background: url("../../assets/img/previous_icon.png") no-repeat center;
}

.paginate_container >>> .next-link-item {
  display: block;
  width: 24px;
  height: 24px;
  background: url("../../assets/img/next_icon.png") no-repeat center;
}
</style>



// WEBPACK FOOTER //
// src/components/personMessage/message.vue